<ng-container *ngIf="filterValue">
	<mat-form-field appearance="outline" class="mat-form-field-custom-width copo-no-error-message" subscriptSizing="dynamic">
		<input matInput [matAutocomplete]="auto" [formControl]="suggestiveCtrl"
				[placeholder]="placeholder ? placeholder : ''" [attr.aria-label]="filter?.label" />
		<copo-loading-spinner matSuffix class="loading-spinner-container-input" *ngIf="isLoading"></copo-loading-spinner>
		@let filteredItemsAsync = filteredItems | async;
		<mat-autocomplete #auto="matAutocomplete">
			@for (proposition of filteredItemsAsync; track getValue(proposition)) {
				<mat-option (onSelectionChange)="propositionChanged(proposition)" [value]="getValue(proposition)">
					{{ getValue(proposition) }}
				</mat-option>
			}
		</mat-autocomplete>
	</mat-form-field>
</ng-container>
